import React from 'react';
import { Helmet } from 'react-helmet';

interface PageWrapProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  id?: string;
}

export default function PageWrap({
  children,
  title = '',
  description,
  id,
}: PageWrapProps) {
  return (
    <>
      <Helmet>
        {title ? <title>{title} | Crafter</title> : <title> Crafter</title>}
        <meta name="description" content={description} />
      </Helmet>
      <main
        id={id}
        className="flex w-full h-full min-h-0 overflow-hidden pt-[10px] pb-[20px] text-sm text-[#7A7A7A] bg-frame-main"
      >
        <div
          className={`h-full min-h-0 overflow-auto flex flex-col flex-1 w-full px-10`}
        >
          {children}
        </div>
      </main>
    </>
  );
}
